import { Loader2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export function LoadingSpinner() {
  const { t } = useI18n();

  return (
    <div className="flex h-full min-h-[200px] items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
        <p className="text-muted-foreground text-sm">{t("common.loading")}</p>
      </div>
    </div>
  );
}
